export enum TipoPagamentoCupom {
  À_Vista = 1,
  Parcelado = 2,
  Parcalado_com_entrada = 3
}
